// #region imports

// --- Angular
import { Pipe, PipeTransform } from '@angular/core';

// #endregion

@Pipe({
  name: 'avatarText'
})
export class AvatarTextPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (!value) {
      return;
    }
    return this._getInitialsFromString(value);
  }

  private _getInitialsFromString(name: string) {
    const parts = name.split(' ');
    let initials = '';
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < parts.length; i++) {
      if (parts[i].length > 0 && parts[i] !== '') {
        initials += parts[i][0];
      }
    }
    return initials.length <= 2 ? initials : initials.substring(0, 2);
  }

}
